import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";
import ShippingRoutesConfigurations from "@/components/logistics/shipping-routes/shipping-routes-configurations";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/shipping-routes",
)({
  component: ShippingRoutesConfigurationsPage,
});

function ShippingRoutesConfigurationsPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "shipping_routes", actions: ["read", "update"] }]}
    >
      <ShippingRoutesConfigurations />
    </RouteGuardPermissions>
  );
}
